import { createUserManager } from 'redux-oidc';
import { IsKD_Login, HasKDpath, IsKD_Inventario } from './KDgeneric';

/////////////////// LOCAL
/* const userManagerConfig = {
    client_id: 'js-local',
    redirect_uri: 'http://localhost:3000/callback.html',
    response_type: 'token id_token',
    scope: 'openid profile ilusionaapi',
    // scope: 'openid profile neuriteapi',
    authority: 'https://ilusionaClubIdentityserver.azurewebsites.net/',
    // authority: 'https://neuriteidentityserver20181019042600.azurewebsites.net/',
    silent_redirect_uri: 'http://localhost:3000/silent_renew.html',
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
}; */

/////////////////// LOCAL - 3AGUAS
// const userManagerConfig = {
//     client_id: 'js-local',
//     redirect_uri: 'http://localhost:3000/callback.html',
//     response_type: 'token id_token',
//     scope: 'openid profile ilusionaapi',
//     // scope: 'openid profile neuriteapi',
//     authority: 'https://3aguas-identityserver.azurewebsites.net/',
//     // authority: 'https://neuriteidentityserver20181019042600.azurewebsites.net/',
//     silent_redirect_uri: 'http://localhost:3000/silent_renew.html',
//     automaticSilentRenew: true,
//     filterProtocolClaims: true,
//     loadUserInfo: true,
// };


/////////////////// test-n-ilu
// const userManagerConfig = {
//     client_id: 'js-ilusiona',
//     redirect_uri: 'https://test-n-ilu.azurewebsites.net/callback.html',
//     response_type: 'token id_token',
//     scope: 'openid profile ilusionaapi',
//     //scope: 'openid profile neuriteapi',
//     authority: 'https://ilusionaIdentityserver.azurewebsites.net/',
//     //authority: 'https://neuriteidentityserver20181019042600.azurewebsites.net/',
//     silent_redirect_uri: 'https://test-n-ilu.azurewebsites.net/silent_renew.html',
//     automaticSilentRenew: true,
//     filterProtocolClaims: true,
//     loadUserInfo: true,
// };


/////////////////// debug-n-ilu
// const userManagerConfig = {
//     client_id: 'js-ilusiona-debug',
//     redirect_uri: 'https://debug-n-ilu.azurewebsites.net/callback.html',
//     response_type: 'token id_token',
//     scope: 'openid profile ilusionaapi',
//     //scope: 'openid profile neuriteapi',
//     authority: 'https://ilusionaIdentityserver.azurewebsites.net/',
//     //authority: 'https://neuriteidentityserver20181019042600.azurewebsites.net/',
//     silent_redirect_uri: 'https://debug-n-ilu.azurewebsites.net/silent_renew.html',
//     automaticSilentRenew: true,
//     filterProtocolClaims: true,
//     loadUserInfo: true,
// };


/////////////////// ilusionadataanalytics
// const userManagerConfig = {
//     client_id: 'js-ilusionadataanalytics',
//     redirect_uri: 'https://ilusionadataanalytics.azurewebsites.net/callback.html',
//     response_type: 'token id_token',
//     scope: 'openid profile ilusionaapi',
//     //scope: 'openid profile neuriteapi',
//     authority: 'https://ilusionaIdentityserver.azurewebsites.net/',
//     //authority: 'https://neuriteidentityserver20181019042600.azurewebsites.net/',
//     silent_redirect_uri: 'https://ilusionadataanalytics.azurewebsites.net/silent_renew.html',
//     automaticSilentRenew: true,
//     filterProtocolClaims: true,
//     loadUserInfo: true,
// };

// /////////////////// 3aguas-tcg
/*  const userManagerConfig = {
     client_id: 'js-3aguas-client',
     redirect_uri: 'https://3aguas-tcg.azurewebsites.net/callback.html',
     response_type: 'token id_token',
     scope: 'openid profile ilusionaapi',
     //scope: 'openid profile neuriteapi',
     authority: 'https://3aguas-identityserver.azurewebsites.net/',
     silent_redirect_uri: 'https://3aguas-tcg.azurewebsites.net/silent_renew.html',
     automaticSilentRenew: true,
     filterProtocolClaims: true,
     loadUserInfo: true,
 }; */


// NOOOOOOOOOOOOO
// const userManagerConfig = {
//     client_id: 'js-ilusiona',
//     redirect_uri: 'https://test-n-ilu.azurewebsites.net/callback.html',
//     response_type: 'token id_token',
//     scope: 'openid profile neuriteapi',
//     authority: 'https://ilusionaIdentityserver.azurewebsites.net/',
//     silent_redirect_uri: 'https://test-n-ilu.azurewebsites.net/silent_renew.html',
//     automaticSilentRenew: true,
//     filterProtocolClaims: true,
//     loadUserInfo: true,
// };

// const userManagerConfig = {
//     client_id: 'js',
//     redirect_uri: 'https://neurite-client.azurewebsites.net/callback.html',
//     response_type: 'token id_token',
//     scope: 'openid profile neuriteapi',
//     authority: 'https://neuriteidentityserver20181019042600.azurewebsites.net/',
//     silent_redirect_uri: 'https://neurite-client.azurewebsites.net/silent_renew.html',
//     automaticSilentRenew: true,
//     filterProtocolClaims: true,
//     loadUserInfo: true,
// };

const userManagerConfig = () => {
    if (!IsKD_Login()) {
        switch (process.env.REACT_APP_CLIENT) {
            case "3aguas-local":
                return {
                    client_id: 'js-local',
                    redirect_uri: 'http://localhost:3000/callback.html',
                    response_type: 'token id_token',
                    scope: 'openid profile ilusionaapi',
                    authority: 'https://3aguas-identityserver.azurewebsites.net/',
                    silent_redirect_uri: 'http://localhost:3000/silent_renew.html',
                    post_logout_redirect_uri: 'http://localhost:3000/index.html',
                    automaticSilentRenew: true,
                    filterProtocolClaims: true,
                    loadUserInfo: true,
                }
            case "3aguas":
                return {
                    client_id: 'js-3aguas-client',
                    redirect_uri: 'https://3aguas-tcg.azurewebsites.net/callback.html',
                    response_type: 'token id_token',
                    scope: 'openid profile ilusionaapi',
                    authority: 'https://3aguas-identityserver.azurewebsites.net/',
                    silent_redirect_uri: 'https://3aguas-tcg.azurewebsites.net/silent_renew.html',
                    post_logout_redirect_uri: 'https://3aguas-tcg.azurewebsites.net/index.html',
                    automaticSilentRenew: true,
                    filterProtocolClaims: true,
                    loadUserInfo: true,
                }
            case "Ilusiona-local":
                return {
                    client_id: 'js-local',
                    redirect_uri: 'http://localhost:3000/callback.html',
                    response_type: 'token id_token',
                    scope: 'openid profile ilusionaapi',
                    authority: 'https://ilusiona-identityserver-prod.azurewebsites.net/',
                    //authority: 'https://ilusionaidentityservertest.azurewebsites.net/',
                    //authority: 'https://localhost:5003/',
                    silent_redirect_uri: 'http://localhost:3000/silent_renew.html',
                    post_logout_redirect_uri: 'http://localhost:3000/index.html',
                    automaticSilentRenew: true,
                    filterProtocolClaims: true,
                    loadUserInfo: true,
                }
            case "Ilusiona":
                // return {
                //     client_id: 'js-ilusiona-debug',
                //     redirect_uri: 'https://debug-n-ilu.azurewebsites.net/callback.html',
                //     response_type: 'token id_token',
                //     scope: 'openid profile ilusionaapi',
                //     authority: 'https://ilusionaClubIdentityserver.azurewebsites.net/',
                //     silent_redirect_uri: 'https://debug-n-ilu.azurewebsites.net/silent_renew.html',
                //     automaticSilentRenew: true,
                //     filterProtocolClaims: true,
                //     loadUserInfo: true,
                // }
                if (HasKDpath() || IsKD_Inventario()) {
                    return {
                        client_id: 'js-ilusiona-tcg-sinlogout',
                        redirect_uri: 'https://tcg.ilusiona.com/callback.html',
                        response_type: 'token id_token',
                        scope: 'openid profile ilusionaapi',
                        authority: 'https://ilusiona-identityserver-prod.azurewebsites.net/',
                        silent_redirect_uri: 'https://tcg.ilusiona.com/silent_renew.html',
                        post_logout_redirect_uri: 'https://tcg.ilusiona.com/logout.html',
                        automaticSilentRenew: true,
                        filterProtocolClaims: true,
                        loadUserInfo: true,
                    }
                } else {
                    return {
                        client_id: 'js-ilusiona-tcg',
                        redirect_uri: 'https://tcg.ilusiona.com/callback.html',
                        response_type: 'token id_token',
                        scope: 'openid profile ilusionaapi',
                        authority: 'https://ilusiona-identityserver-prod.azurewebsites.net/',
                        silent_redirect_uri: 'https://tcg.ilusiona.com/silent_renew.html',
                        post_logout_redirect_uri: 'https://tcg.ilusiona.com/index.html',
                        automaticSilentRenew: true,
                        filterProtocolClaims: true,
                        loadUserInfo: true,
                    }
                }

            default:
                break;
        }
    } else {
        // Para kd el callback es al callback de KD
        switch (process.env.REACT_APP_CLIENT) {
            case "Ilusiona-local":
                return {
                    client_id: 'js-local-kd',
                    redirect_uri: 'http://localhost:3000/callback_kd.html',
                    response_type: 'token id_token',
                    scope: 'openid profile ilusionaapi',
                    authority: 'https://ilusiona-identityserver-prod.azurewebsites.net/',
                    //authority: 'https://ilusionaidentityserver.azurewebsites.net/',
                    //authority: 'https://localhost:5003/',
                    silent_redirect_uri: 'http://localhost:3000/silent_renew.html',
                    post_logout_redirect_uri: 'http://localhost:3000/index.html',
                    automaticSilentRenew: true,
                    filterProtocolClaims: true,
                    loadUserInfo: true,
                }
            case "Ilusiona":
                return {
                    client_id: 'js-ilusiona-tcg-kd',
                    redirect_uri: 'https://tcg.ilusiona.com/callback_kd.html',
                    response_type: 'token id_token',
                    scope: 'openid profile ilusionaapi',
                    authority: 'https://ilusiona-identityserver-prod.azurewebsites.net/',
                    //authority: 'https://ilusionaidentityserver.azurewebsites.net/',
                    silent_redirect_uri: 'https://tcg.ilusiona.com/silent_renew.html',
                    post_logout_redirect_uri: 'https://tcg.ilusiona.com/index.html',
                    automaticSilentRenew: true,
                    filterProtocolClaims: true,
                    loadUserInfo: true,
                }

            default:
                break;
        }
    }
}

const userManager = createUserManager(userManagerConfig());

export default userManager;